import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTE_BACK_OFFICE_PROMPT_TEMPLATES } from '../../../constants';

const AgentPrompts = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate(ROUTE_BACK_OFFICE_PROMPT_TEMPLATES, { replace: true }); }, [navigate]);
  return null;
};

export default AgentPrompts;
